import React from "react";
import styled, { css } from "styled-components";

interface ITagProps {
  value?: string;
  color?: string;
}

const Tag = (props: ITagProps) => {
  return <TagSet color={props.color}>{props.value}</TagSet>;
};

const TagSet = styled.span<ITagProps>`
  display: inline-block;
  min-width: 60px;
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  ${(props) => {
    switch (props.color) {
      case "level0":
        return css`
          background-color: ${({ theme }) => theme.color.warning};
        `;
      case "level1":
        return css`
          background-color: ${({ theme }) => theme.color.bgPrimary};
          color: ${({ theme }) => theme.color.primary};
        `;
      case "level2":
        return css`
          background-color: #9fbcec;
        `;
      case "level3":
        return css`
          background-color: #96aff0;
        `;
      case "level4":
        return css`
          background-color: #6487eb;
        `;
      case "level5":
        return css`
          background-color: ${({ theme }) => theme.color.main};
        `;
      default:
        return css`
          background-color: #ebf0f5;
          color: #60677d;
        `;
    }
  }}
`;

export default Tag;
